// src/components/Shared/ConfirmDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import WarningIcon from '@mui/icons-material/Warning';

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: 4,
        minWidth: 400
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: '#f44336',
        fontWeight: 600
    },
    content: {
        paddingTop: theme.spacing(2)
    }
}));

const ConfirmDialog = ({
    open,
    onClose,
    onConfirm,
    title = '¿Confirmar acción?',
    message,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    confirmColor = 'secondary'
}) => {
    const classes = useStyles();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle>
                <Box className={classes.title}>
                    <WarningIcon />
                    {title}
                </Box>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions style={{ padding: 16 }}>
                <Button onClick={onClose} variant="outlined">
                    {cancelText}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color={confirmColor}
                    style={{
                        backgroundColor: confirmColor === 'secondary' ? '#f44336' : undefined
                    }}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;